<template>
  <div
    class="xl:hidden sticky top-0 z-30 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 transition-colors duration-300"
  >
    <div class="max-w-6xl mx-auto px-4 py-1">
      <div class="flex items-center justify-between">
        <button
          type="button"
          aria-label="Open navigation menu"
          class="flex items-center gap-1.5 px-2.5 py-1.5 text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
          @click="openMobileSidebar"
        >
          <IconMenu class="w-6 h-6" />
          <span v-translate="'common.menu'" class="text-sm font-medium"></span>
        </button>
        <RouterLink :to="{ name: 'payment' }" aria-label="YouPark" class="inline-flex items-center leading-none">
          <IconLogo />
        </RouterLink>
        <div class="flex items-center gap-1">
          <button
            v-if="canShowQuickNav"
            type="button"
            :aria-label="translate('quickNav.ariaLabel')"
            class="p-2 text-gray-500 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
            @click="openQuickNav"
          >
            <IconSearch class="w-5 h-5" />
          </button>
          <LanguageSwitcher compact />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LanguageSwitcher from "@core/components/shared/LanguageSwitcher.vue";
import { useNavigation } from "@core/composables/state/useNavigation";
import { useQuickNav } from "@core/composables/state/useQuickNav";
import IconLogo from "@core/icons/IconLogo.vue";
import IconMenu from "@core/icons/IconMenu.vue";
import IconSearch from "@core/icons/IconSearch.vue";

import { useTranslate } from "@common/composables/useTranslate";

const translate = useTranslate();
const { openMobileSidebar } = useNavigation();
const { open: openQuickNav, canShow: canShowQuickNav } = useQuickNav();
</script>
